"use client";

import { cn } from "../../utils/cn.util";
import { Button, type ButtonProps } from "../button";
import { Card } from "../card";
import { FeatureIcon, type FeatureIconProps } from "../feature-icon";

export type AccessRestrictionProps = {
  className?: string;
  title: string;
  description: string;
  featureIcon: FeatureIconProps;
  ctaButton: ButtonProps;
};

const AccessRestriction = ({ className, title, description, featureIcon, ctaButton }: AccessRestrictionProps) => {
  return (
    <Card.Root className={cn("mx-auto mt-30 w-120 shadow-lg", className)}>
      <Card.Body className="p-6">
        <FeatureIcon className="mx-auto" size="xl" {...featureIcon} />
        <div className="text-center">
          <h1 className="text-xl leading-6 font-bold">{title}</h1>
          <p className="mt-1 text-base leading-6 text-neutral-50">{description}</p>
        </div>
        <Button className="mx-auto mt-4 w-fit" size="sm" {...ctaButton} />
      </Card.Body>
    </Card.Root>
  );
};

export default AccessRestriction;
